/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlCourses = "/courses";
const urlLessons = "/course-lessons";
const urlPrice = "/course-prices";
const urlStudent = "/course-student";
const urlSettings = "/course-settings";
const urlClasses = "/course-classes";
const urlTimetables = "/course-timetables";

const state = {
  courses: [],
  lessons: [],
  prices: [],
  students: [],
  studentSelecting: {},
  classes: [],
  classSelecting: {},
  classesWithoutGroups: [],
  settings: [],
  courseDetail: {},
  pagination: {
    current_page: 1,
    per_page: 15,
    total: 0,
  },
};

const actions = {
  /**
   * Get list courses
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListCourses({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlCourses}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST_COURSES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Get list lessons
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListCourseLessons({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlLessons}?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        commit("SET_LIST_LESSONS", response.data.data.items);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Get list setting
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListCourseSettings({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlSettings}?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        commit("SET_LIST_SETTINGS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * create setting
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  addSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(urlSettings, payload)
        .then((response) => {
          state.settings.unshift(response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateSetting({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${urlSettings}/${id}`, payload)
        .then((response) => {
          const pos = state.settings
            .map(function (e) {
              return e.id;
            })
            .indexOf(response.data.data.id);
          state.settings.splice(pos, 1, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Get list class
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListCourseClasses({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlClasses}?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        commit("SET_LIST_CLASSES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * create class
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  addClass({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(urlClasses, payload)
        .then((response) => {
          commit("ADD_CLASS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateClass({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${urlClasses}/${id}`, payload)
        .then((response) => {
          commit("UPDATE_CLASS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getClassDetail({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlClasses}/${id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_CLASS_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateTimetables({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${urlTimetables}/${id}`, payload)
        .then((response) => {
          commit("UPDATE_CLASS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Get list prices
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListCoursePrices({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlPrice}?${new URLSearchParams(query)}`
      );
      if (response.status === 200) {
        commit("SET_LIST_PRICES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * Get list students
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListCourseStudents({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlStudent}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST_STUDENTS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Detail
   * @param commit
   * @param id
   * @returns {Promise<{}|*>}
   */
  async detail({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlCourses}/${id}?include=levels`)
        .then((response) => {
          commit("SET_COURSE_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async addLesson({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(urlLessons, payload)
        .then((response) => {
          commit("ADD_LESSON", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async cloneClassesByDay({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${urlCourses}/clone-classes-by-day`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async cloneClassesByWeek({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${urlCourses}/clone-classes-by-week`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Update
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async editLesson({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${urlLessons}/${id}?`, payload)
        .then((response) => {
          commit("UPDATE_LESSON", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async createPrice({ commit }, payload) {
    return await axios.post(urlPrice, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * Update
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async updatePrice({ commit }, { id, payload }) {
    return await axios.put(`${urlPrice}/${id}?`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async createStudent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(urlStudent, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          commit("ADD_STUDENT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateStudent({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${urlStudent}/${id}`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          commit("UPDATE_STUDENT", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getStudentDetail({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlStudent}/${id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_STUDENT_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlCourses, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * Update
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${urlCourses}/${id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteLessons({ commit }, payload) {
    return await axios.post(`${urlLessons}/delete-multiple`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * Delete
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deletePrices({ commit }, payload) {
    return await axios.post(`${urlPrice}/delete-multiple`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * Delete
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteStudents({ commit }, payload) {
    return await axios.post(`${urlStudent}/delete-multiple`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * delete multiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(`${urlCourses}/delete-multiple`, payload, {
      headers: { "Content-Type": "application/json" },
    });
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_COURSES(state, data) {
    state.courses = data.items;
    state.pagination = data.pagination;
  },
  SET_LIST_LESSONS(state, data) {
    state.lessons = data;
  },
  SET_LIST_PRICES(state, data) {
    state.prices = data.items;
  },
  SET_LIST_STUDENTS(state, data) {
    state.students = data.items;
    state.pagination = data.pagination;
  },
  SET_LIST_SETTINGS(state, data) {
    state.settings = data.items;
  },
  SET_LIST_CLASSES(state, data) {
    state.classes = data.items;
    state.classesWithoutGroups = data.items.filter((item) => {
      return item.group_id === null || item.group_id === undefined;
    });
  },
  ADD_CLASS(state, data) {
    state.classes.unshift(data);
    mutations.syncTimetables(state, data);
    state.classesWithoutGroups = state.classes.filter((item) => {
      return item.group_id === null || item.group_id === undefined;
    });
  },
  UPDATE_CLASS(state, data) {
    const pos = state.classes
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.classes.splice(pos, 1, data);
    mutations.syncTimetables(state, data);
    state.classesWithoutGroups = state.classes.filter((item) => {
      return item.group_id === null || item.group_id === undefined;
    });
  },
  ADD_LESSON(state, data) {
    state.lessons.unshift(data);
  },
  UPDATE_LESSON(state, data) {
    const pos = state.lessons
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.lessons.splice(pos, 1, data);
  },
  ADD_STUDENT(state, data) {
    state.students.unshift(data);
  },
  UPDATE_STUDENT(state, data) {
    const pos = state.students
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.students.splice(pos, 1, data);
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  SET_COURSE_DETAIL(state, data) {
    state.courseDetail = data;
  },
  SET_CLASS_DETAIL(state, data) {
    state.classSelecting = data;
  },
  SET_STUDENT_DETAIL(state, data) {
    state.studentSelecting = data;
  },
  syncTimetables(state, data) {
    // Để không phải load toàn bộ class,
    // Thì ở đây sẽ map class_name (case user thay đổi class_name)
    // cho tất cả class cùng nhóm với nó (booking sẽ có 1 nhóm các class)
    if (data.group_id !== null) {
      state.classes = state.classes.map((item) => {
        if (data.group_id === item.group_id || data.group_id === item.id) {
          item.class_name = data.class_name;
          item.timetables = item.timetables.map((e) => {
            e.class.class_name = data.class_name;
            return e;
          });
        }
        return item;
      });
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
